export type CreatorActor = {
  id?: number;
  name?: string;
  user_name?: string | null;
  role?: string | null;
};

export function getCreatorDisplayName(actor?: CreatorActor | null): string {
  const name = actor?.name?.trim() || actor?.user_name?.trim();
  if (name) return name;
  if (actor?.id != null) return `User #${actor.id}`;
  return "—";
}

/** Mobile feed footer: `by Name` or `by Name (Resident)` when role is Resident. */
export function getMobileFeedCreatorAttribution(actor?: CreatorActor | null): string | null {
  const name = actor?.name?.trim() || actor?.user_name?.trim();
  if (!name) return null;
  if (actor?.role?.trim().toLowerCase() === "resident") {
    return `by ${name} (Resident)`;
  }
  return `by ${name}`;
}
